import classNames from 'classnames';
import React from 'react';
import {observer} from 'mobx-react';

import {CourseRibbonWrapper} from '@udemy-v2/react-browse-course';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {useSmartBarRef} from '@udemy-v2/react-smart-bar';
import {RatingsWithEnrollments} from '../rating-display/ratings-with-enrollments.react.component';

import styles from './sticky-header.module.scss';

interface StickyHeaderProps {
    title: string;
}

export const StickyHeader = observer(({title}: StickyHeaderProps) => {
    const course = useClpCourse();
    const {smartBarHeight, isSticky, isHidden} = useSmartBarRef();

    const shouldApplyOffset = isSticky && !isHidden;

    return (
        <div className={'ud-color-scheme-dark'}>
            <div
                className={styles['sticky-header-container']}
                style={shouldApplyOffset ? {top: `${smartBarHeight}px`} : {}}
            >
                <div className={classNames('ud-text-bold', 'ud-text-md', styles['title'])}>
                    {title}
                </div>
                <div className={styles['info']}>
                    {!course.isInGooglePartnerCollection && (
                        <CourseRibbonWrapper course={course} numberOfBadgesToShow={2} />
                    )}
                    <RatingsWithEnrollments numeric={true} />
                </div>
            </div>
        </div>
    );
});
